<template>
  <div class="order-dialog" @contextmenu.stop>
    <el-dialog
      title="开票信息"
      width="600px"
      height="600px"
      top="50px"
      custom-class="order-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="content-wrapper">
        <div class="invoice-item">
          <div class="title"><span>*</span> 企业名称</div>
          <div class="content">{{ invoiceInfo.invoiceTitle }}</div>
        </div>
        <div class="invoice-item">
          <div class="title"><span>*</span>纳税人识别号</div>
          <div class="content">{{ invoiceInfo.taxpayerCode }}</div>
        </div>
        <div class="invoice-item">
          <div class="title"><span>*</span>地址</div>
          <div class="content">{{ invoiceInfo.invoiceAddress }}</div>
        </div>
        <div class="invoice-item">
          <div class="title"><span>*</span>电话</div>
          <div class="content">{{ invoiceInfo.invoicePhone }}</div>
        </div>
        <div class="invoice-item">
          <div class="title"><span>*</span>开户行</div>
          <div class="content">{{ invoiceInfo.openBank }}</div>
        </div>
        <div class="invoice-item">
          <div class="title"><span>*</span>账号</div>
          <div class="content">{{ invoiceInfo.bankAccount }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'InvoiceInfo',
  data() {
    return {
      dialogVisible: false,
      invoiceInfo: {}
    }
  },
  props: {
    invoice: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.invoiceInfo = this.invoice
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.order-dialog {
  .invoice-item {
    display: flex;
    font-size: 14px;
    margin-bottom: 30px;
    justify-content: center;
    .title {
      width: 100px;
      text-align: right;
      margin-right: 45px;
      span {
        color: #df5813;
      }
    }
    .content {
      width: 230px;
      text-align: left;
    }
  }
}
</style>
